// Unified health check helper - only GET requests
// Replaces all health endpoint calls with GET /health

export async function fetchHealth() {
  const base = import.meta.env.VITE_API_URL || 'https://destiny-reborn.onrender.com';
  const res = await fetch(`${base}/health`, { 
    method: 'GET', 
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  
  if (!res.ok) {
    throw new Error(`Health failed: ${res.status}`);
  }
  
  return res.json();
}